import React, { useMemo } from "react";
import { usePortfolio } from "../../contexts/PortfolioContext";
import LogoBadge from "../public/LogoBadge";
import SectionHeading from "../public/SectionHeading";

const Education = () => {
  const { portfolioData } = usePortfolio();

  const allEducation = useMemo(
    () => [
      ...(portfolioData.education || []),
      ...(portfolioData.certifications || []),
    ],
    [portfolioData.education, portfolioData.certifications]
  );

  if (allEducation.length === 0) return null;

  return (
    <section className="public-section public-section--tint" id="education">
      <div className="container">
        <SectionHeading
          eyebrow="Education"
          title="Learning & credentials"
          description="Degrees, programs, and industry bootcamps that shaped how I approach software."
          aside={
            <span className="section-count">
              {allEducation.length}{" "}
              {allEducation.length === 1 ? "program" : "programs"}
            </span>
          }
        />

        <div className="row education-grid">
          {allEducation.map((edu, index) => {
            const score = edu.gpa || edu.score;
            const isBootcamp = edu.type === "bootcamp";

            return (
              <div
                className="col s12 m6 l4"
                key={`${edu.title}-${index}`}
              >
                <article className="education-card">
                  <div className="education-card-head">
                    <LogoBadge
                      src={edu.logo}
                      alt={edu.title}
                      fallback={(edu.title || "?").charAt(0)}
                    />
                    <div className="education-heading">
                      <h3 className="education-title">{edu.title}</h3>
                      {(edu.degree || edu.major) && (
                        <p className="education-meta">
                          {[edu.degree, edu.major]
                            .filter(Boolean)
                            .join(" · ")}
                        </p>
                      )}
                      {edu.period && (
                        <p className="education-period">{edu.period}</p>
                      )}
                    </div>
                  </div>

                  <div className="education-body">
                    {edu.description && (
                      <p className="education-description">
                        {edu.description}
                      </p>
                    )}

                    {edu.achievements?.length > 0 && (
                      <ul className="education-achievements">
                        {edu.achievements.map((achievement, achievementIndex) => (
                          <li
                            key={`${edu.title}-achievement-${achievementIndex}`}
                          >
                            {achievement}
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="education-footer">
                      {score ? (
                        <span className="education-score">
                          {isBootcamp ? "Score" : "GPA"} {score}
                        </span>
                      ) : (
                        <span />
                      )}
                      <span className="education-type">
                        {isBootcamp ? "Bootcamp" : "Degree"}
                      </span>
                    </div>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
